import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class TwoFAService {
  async getQrCode() {
    return (await fetchApi.get(`/user/getQrCode`)).data;
  }

  async verify2FA(code) {
    return (await fetchApi.get(`/user/verify2FA?&code=${encodeURIComponent(code)}`)).data;
  }
}
